export default function itemColor(type){
    let color = "162,175,184";
    switch(type){
      case "zzyd": color = "252,128,4"; break;
      case "syyd": color = "255,0,66"; break;
      case "gyyd": color = "151,111,76"; break;
      case "wlcc": color = "161,126,255"; break;

      case "syjz": color = "255,0,66"; break;
      case "gyjz": color = "151,111,76"; break;
      case "wlck": color = "161,126,255"; break;
      case "nzjd": color = "252,128,4"; break;

      default: color = "128,128,128";
    }

    return color;
}
